import React, { useState } from "react";
import {
  Modal,
  Divider,
  List,
  Typography,
  Flex,
  // Dropdown,
} from "antd";
import { toast } from "react-toastify";
// import { EllipsisOutlined } from "@ant-design/icons";
import RuleStatusTag from "./RuleStatusTag";
import "./QcRuleDetailsModal.css";
import EditQcRuleModal from "./EditQcRuleModal";
import { getMlQcRules } from "../../../../actions/qc";

const { Text } = Typography;

// const menuItems = [
//   { key: "edit", label: "Edit" },
//   { key: "delete", label: "Delete" },
// ];

const QcRuleDetailsModal = ({
  open,
  onCancel,
  ruleData: rule,
  // onDelete,
  // refetch,
}) => {
  const [ruleData, setRuleData] = useState(rule);
  const [loading, setLoading] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  /**
   * handles selecting option in dropdown menu
   * @param {*} menuOption selected option
   */
  // const onMenuItemClick = (menuOption) => {
  //   if (menuOption.key === "edit") {
  //     setShowEditModal(true);
  //   }
  //   if (menuOption.key === "delete") {
  //     onDelete();
  //   }
  // };

  /**
   * fetch updated rule data
   */
  const getRuleData = async () => {
    const params = { rule_id: ruleData.rule_id };
    setLoading(true);
    const response = await getMlQcRules(params);
    setLoading(false);
    if (response.success) {
      setRuleData(response.result?.length ? response.result[0] : rule);
    } else {
      toast.error(response.message || "Something went wrong!");
    }
  };

  return (
    <>
      <Modal
        centered
        title="QC Rule Details"
        width={900}
        open={open}
        onCancel={onCancel}
        rootClassName="QcRuleDetailsModal"
        footer={null}
        loading={loading}
      >
        <div className="QcRuleDetailsModal__Content">
          <Flex vertical align="stretch" gap={16}>
            <Flex align="center" justify="space-between" gap={8}>
              <h4 className="QcRuleDetailsModal__Title">
                <strong>Rule ID : </strong>
                <span>{ruleData.rule_id || "QC Rule"}</span>
              </h4>
              <div className="QcRuleDetailsModal__Status">
                <Text strong>Status: </Text>
                <RuleStatusTag result={ruleData.is_active} />
                {/* <Dropdown
                  type="primary"
                  menu={{
                    items: menuItems,
                    onClick: onMenuItemClick,
                  }}
                  className="QcRuleDetailsModal__ActionDropdown"
                >
                  <EllipsisOutlined className="QcRuleDetailsModal__ActionIcon" />
                </Dropdown> */}
              </div>
            </Flex>
            <h4 className="QcRuleDetailsModal__Title">
              <strong>Type : </strong>
              <span>{ruleData.rule_type}</span>
            </h4>
            <h4 className="QcRuleDetailsModal__Title">
              <strong>Description : </strong>
              <span>{ruleData.rule_description || "-"}</span>
            </h4>
          </Flex>

          <Divider />

          <h4 className="QcRuleDetailsModal__Title">
            <strong>Details : </strong>
          </h4>
          {ruleData.rule_details?.conditions?.length > 0 ? (
            <List
              className="QcRuleDetailsModal__ConditionsList"
              dataSource={ruleData.rule_details.conditions}
              renderItem={(condition, index) => (
                <List.Item key={index} className="QcRuleDetailsModal__ConditionDisplay">
                  <Text>{condition}</Text>
                </List.Item>
              )}
            />
          ) : (
            <div className="QcRuleDetailsModal__NoConditions">
              <Text type="secondary">No conditions defined</Text>
            </div>
          )}
        </div>
      </Modal>
      {showEditModal && (
        <EditQcRuleModal
          open={showEditModal}
          onCancel={() => setShowEditModal(false)}
          editData={ruleData}
          refetch={getRuleData}
        />
      )}
    </>
  );
};

export default QcRuleDetailsModal;
